import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import analytics from '../../analytics';
import { ICmsContent, ICmsError } from '../../interfaces';
import { parseHTML } from '../../services/transformCmsData';
import { isCmsContent } from '../../services/typeGuards';
import type { AppStoreState } from '../../store';
import { getCmsContent } from '../../store/actions';
import LayoutSelfService from '../LayoutSelfService';
import SpinnerView from '../SpinnerView';

import classes from './TermsView.module.css';

type TCmsContent = { content: ICmsError | ICmsContent; cmsSlug: string };
function CmsContent({ content, cmsSlug }: TCmsContent) {
  if (!isCmsContent(content)) {
    return (
      <section data-testid="terms-content-error">
        <h2>Content Unavailable</h2>
        <p>Please try refreshing the page.</p>
      </section>
    );
  }
  const matchedContent = content?.entries?.find(
    (entry) => entry.slug === cmsSlug
  );
  const html = matchedContent?.fields || [];
  return (
    <section data-testid="terms-content">
      {html?.map((htmlSection) => {
        return (
          <section key={htmlSection?.id}>
            {parseHTML(htmlSection?.text || '')}
          </section>
        );
      })}
    </section>
  );
}

type TTermsView = {
  cmsSlug: string;
};

function TermsView({ cmsSlug }: TTermsView) {
  const dispatch = useDispatch();
  const content = useSelector(
    (state: AppStoreState) => state.cmsContent?.['terms-and-conditions']
  );

  useEffect(
    function getCms() {
      if (!content) {
        getCmsContent(['terms-and-conditions'])(dispatch);
      }
    },
    [content, dispatch]
  );

  useEffect(() => {
    analytics.page();
  }, []);

  if (!content) {
    return <SpinnerView />;
  }

  return (
    <LayoutSelfService
      className={classes.root}
      header="Terms and Conditions"
      hasBackgroundImage={false}
    >
      <CmsContent content={content} cmsSlug={cmsSlug} />
    </LayoutSelfService>
  );
}
export default TermsView;
